<template>
  <MapSettings />
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import MapSettings from '@/components/builder/MapSettings/MapSettings.vue'

const components = {
  MapSettings,
}

@Component({ components })
export default class MapSettingsView extends Vue {}
</script>
